export const LipSyncModel = {
	// creatify: {
	// 	id: "creatify",
	// 	name: "Creatify",
	// 	info: "Normal lip sync",
	// 	require_subs: false,
	// 	require_credits: 15,
	// 	loop: {
	// 		support: true,
	// 		loopModes: ["loop", "none"]
	// 	},
	// 	params: {
	// 		model_id: "creatify/lipsync",
	// 		model_input: {
	// 			video_url: "{video_url}",
	// 			audio_url: "{audio_url}",
	// 			loop: "{loop_mode}"
	// 		}
	// 	}
	// },
	latentsync: {
		id: "latentsync",
		name: "Latent Sync",
		info: "Fast generation / 2 loop modes",
		require_subs: false,
		require_credits: 1,
		loop: {
			support: true,
			loopModes: ["pingpong", "loop"],
			defaultLoopMode: "pingpong"
		},
		params: {
			model_id: "fal-ai/latentsync",
			model_input: {
				video_url: "{video_url}",
				audio_url: "{audio_url}",
				loop_mode: "{loop_mode}"
			}
		}
	},
	// veedsync: {
	// 	id: "veedsync",
	// 	name: "Veed Sync",
	// 	info: "Generate realistic lipsync",
	// 	require_subs: false,
	// 	require_credits: 1,
	// 	loop: {
	// 		support: false,
	// 		loopModes: [],
	// 		defaultLoopMode: "",
	// 		info: "Veed Sync model will auto extends video by AI when audio is longer than video"
	// 	},
	// 	params: {
	// 		model_id: "veed/lipsync",
	// 		model_input: {
	// 			video_url: "{video_url}",
	// 			audio_url: "{audio_url}"
	// 		}
	// 	}
	// },
	klingsync: {
		id: "klingsync",
		name: "Kling Lip Sync",
		info: "AI auto extends your video",
		require_subs: false,
		require_credits: 1,
		loop: {
			support: false,
			loopModes: [],
			defaultLoopMode: "",
			info: "Kling model will auto extends video by AI when audio is longer than video"
		},
		params: {
			model_id: "fal-ai/kling-video/lipsync/audio-to-video",
			model_input: {
				video_url: "{video_url}",
				audio_url: "{audio_url}"
			}
		}
	},
	sync_v1_9: {
		id: "sync_v1_9",
		name: "Sync V1.9",
		info: "Quality with speed / 5 loop modes",
		require_subs: false,
		require_credits: 1,
		loop: {
			support: true,
			loopModes: ["cut_off", "loop", "bounce", "silence", "remap"],
			defaultLoopMode: "bounce"
		},
		params: {
			model_id: "fal-ai/sync-lipsync",
			model_input: {
				model: "lipsync-1.9.0-beta",
				video_url: "{video_url}",
				audio_url: "{audio_url}",
				sync_mode: "{sync_mode}"
			}
		}
	}
}

export const EndPoints = {
	POST_TASK: process.env.NODE_ENV === "development" ? "/api/generate-lipsync" : "/api/generate-lipsync",
	GET_TASK: process.env.NODE_ENV === "development" ? "/api/generate-lipsync" : "/api/generate-lipsync"
}
